import {useCookie} from '#app'

interface UserInfo {
    id?: number
    nickname?: string
    avatar?: string

    [key: string]: any
}

export const useUserInfo = () => {
    const userInfo = useState<UserInfo | null>('user-info', () => null)

    /**
     * 获取用户信息
     * 优先从接口获取；失败时回退到 cookie 或 localStorage
     */
    const getUserInfo = async () => {
        try {
            const res = await clientFetch('/api/me/get-user-info')
            const loginInfo = useCookie<any>('login_info', {path: '/'})

            if (res.code === 0) {
                userInfo.value = res.data
                if (process.client) {
                    localStorage.setItem('login_info', JSON.stringify(res.data))
                }
                loginInfo.value = res.data
            } else {
                // fallback: 从 cookie 或 localStorage 取
                const local =
                    loginInfo.value ||
                    (process.client
                        ? JSON.parse(localStorage.getItem('login_info') || 'null')
                        : null)
                userInfo.value = local
                console.log('从cookie获取用户信息--------->>>', userInfo.value)
            }
        } catch (e) {
            console.error('getUserInfo error', e)
            // 网络或接口异常时 fallback
            const loginInfo = useCookie<any>('login_info', {path: '/'})
            userInfo.value =
                loginInfo.value ||
                (process.client
                    ? JSON.parse(localStorage.getItem('login_info') || 'null')
                    : null)
        }

        return userInfo.value
    }

    /**
     * 清除用户信息（退出登录时用）
     */
    const clearUserInfo = () => {
        const loginInfo = useCookie('login_info', {path: '/'})
        loginInfo.value = null
        userInfo.value = null
        if (process.client) {
            localStorage.removeItem('login_info')
        }
    }

    return {
        userInfo,
        getUserInfo,
        clearUserInfo,
    }
}
